import { FC } from "react";
import { Box, Container, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { LandingPageContent } from "@/constants/landingPages";

interface LandingIntegrationSectionProps {
  content: LandingPageContent["integration"];
}

export const LandingIntegrationSection: FC<LandingIntegrationSectionProps> = ({ content }) => (
  <Box py={{ base: "16", md: "24" }} bg="gray.50">
    <Container maxW="7xl">
      <Flex
        direction={{ base: "column", lg: "row" }}
        align="center"
        gap={{ base: "8", lg: "16" }}
      >
        {/* Left: text */}
        <VStack align={{ base: "center", lg: "flex-start" }} spacing="6" flex="1" textAlign={{ base: "center", lg: "left" }}>
          <Heading as="h2" fontSize={{ base: "3xl", md: "4xl" }} color="gray.900">
            {content.title}
          </Heading>
          <Text fontSize={{ base: "lg", md: "xl" }} color="gray.600" lineHeight="1.7">
            {content.description}
          </Text>
          <VStack align={{ base: "center", lg: "flex-start" }} spacing="3" pt="4">
            <Flex align="center" gap="3">
              <Box fontSize="2xl">📦</Box>
              <Text fontSize="lg" fontWeight="600" color="gray.700">{content.methods.javascript}</Text>
            </Flex>
            <Flex align="center" gap="3">
              <Box fontSize="2xl">🔧</Box>
              <Text fontSize="lg" fontWeight="600" color="gray.700">{content.methods.html}</Text>
            </Flex>
          </VStack>
        </VStack>

        {/* Right: illustration/diagram */}
        <Box flex="1" maxW={{ base: "100%", lg: "500px" }}>
          <Box
            bg="white"
            borderRadius="xl"
            p="8"
            boxShadow="lg"
            border="1px solid"
            borderColor="gray.200"
          >
            <VStack spacing="6">
              <Box
                bg="blue.50"
                borderRadius="lg"
                p="6"
                w="100%"
                textAlign="center"
              >
                <Text fontSize="3xl" mb="2">📱</Text>
                <Text fontSize="lg" fontWeight="bold" color="gray.900">{content.platformName} {content.diagram.appLabel}</Text>
              </Box>

              <Text fontSize="2xl" color="gray.400" fontWeight="bold">↓</Text>

              <Box
                bg="green.50"
                borderRadius="lg"
                p="6"
                w="100%"
                textAlign="center"
                border="2px dashed"
                borderColor="green.300"
              >
                <Text fontSize="3xl" mb="2">🎨</Text>
                <Text fontSize="lg" fontWeight="bold" color="gray.900">{content.diagram.widgetLabel}</Text>
                <Text fontSize="sm" color="gray.600" mt="2">{content.diagram.brandLabel}</Text>
              </Box>
            </VStack>
          </Box>
        </Box>
      </Flex>
    </Container>
  </Box>
);
